import "./App.scss";
import {
  Route,
  Switch,
  Redirect,
  HashRouter,
} from "react-router-dom";
import Login from "../Login/Login";
import Dashboard from "../../layouts/Dashboard/Dashboard";
import Launcher from "../../pages/Launcher";
import Registration from "../../pages/Registration";
import Tournament from "../../pages/Tournament";
import { useAuthStore } from "../../store/auth";
import { useConfigProvider } from "../../contexts/ConfigProvider";
import { useSearchStore } from "../../store/search";

function App() {
  const isAuth = useAuthStore((state) => state.isAuth);
  const search = useSearchStore((state) => state.search);
  const { config, slots, vb, features, promotedGame, defaultGameLanguage } = useConfigProvider();

  return (
    <HashRouter>
      <div className="showroom">
        <div className="showroom-body">
          <div className="showroom-content">
              <Switch>
                <Route exact path="/tournament">
                  { (!isAuth && features.withLogin) ? <Login loginUrl={config.login_url}/> : features.withTournamentPage ? <Tournament gameUrl={config.game_url}/> : <></>} 
                </Route>
                <Route exact path="/registration">
                  { features.withRegistrationPage ? <Registration registrationApiUrl={config.login_url} gameUrl={config.game_url} promotedGame={promotedGame}/> : <></>} 
                </Route>
                <Route exact path="/launcher">
                  {(!isAuth && features.withLogin) ? <Login loginUrl={config.login_url}/> : features.withLauncher ? <Launcher slots={slots} vb={vb} config={config}/> : <></>} 
                </Route>
                <Route exact path="/slots">
                  {(!isAuth && features.withLogin) ? <Login loginUrl={config.login_url}/> : (
                    <Dashboard
                      games={slots.games.filter((game) =>
                        game.name.toLowerCase().includes(search.toLowerCase())
                      )}
                      filtering={search.length > 0}
                      gameUrl={config.game_url}
                      baseUrl={config.operatorApiUrl}
                      configUrl={config.config_url}
                      defaultGameLanguage={defaultGameLanguage}
                    />
                  )}
                </Route>
                <Route exact path="/vb">
                  {(!isAuth && features.withLogin) ? <Login loginUrl={config.login_url}/> : (
                    <Dashboard
                      games={vb.games.filter((game) =>
                        game.name.toLowerCase().includes(search.toLowerCase())
                      )}
                      filtering={search.length > 0}
                      gameUrl={config.game_url}
                      baseUrl={config.operatorApiUrl}
                      configUrl={config.config_url}
                      defaultGameLanguage={defaultGameLanguage}
                    />
                  )}
                </Route>
                <Route exact path="/" render={() => <Redirect to="/slots" />} />
              </Switch>
          </div>
        </div>
      </div>
    </HashRouter>
  );
}

export default App;
